import React from "react";
import { createRoot } from "react-dom/client";
import About from "../components/About.jsx";

const root = createRoot(document.getElementById("root"));
root.render(<About />);
